// @flow

import React from 'react';
import type { Node } from 'react';
import { FormattedMessage } from 'react-intl';
import { Heading, Paragraph, Button } from '@riseart/common';
import { VisuallySimilarIcon, WishlistIcon } from '@riseart/icons';
import { UrlAssembler } from 'shared_services/riseart/utils/UrlAssembler';

import {
  noWishlistCls,
  noWishlistFirstParagraphCls,
} from 'shared_components/wishlist/NoWishlistItems.less';

/**
 * NoWishlistItems
 *
 * @returns {Node}
 */
export function NoWishlistItems(): Node {
  return (
    <div className={noWishlistCls}>
      <Heading tag="h3" level="3">
        <FormattedMessage id="components.wishlist.noItems.title">
          {(title: string) => title}
        </FormattedMessage>
      </Heading>
      <Paragraph className={noWishlistFirstParagraphCls}>
        <FormattedMessage
          id="components.wishlist.noItems.descriptionLine1"
          values={{ wishlistIcon: <WishlistIcon /> }}
        >
          {(description: string) => description}
        </FormattedMessage>
      </Paragraph>
      <Paragraph>
        <FormattedMessage
          id="components.wishlist.noItems.descriptionLine2"
          values={{ visuallySimilarIcon: <VisuallySimilarIcon /> }}
        >
          {(description: string) => description}
        </FormattedMessage>
      </Paragraph>

      <FormattedMessage id="components.wishlist.noItems.button">
        {(text: string) => (
          <Button isAnchor to={UrlAssembler.artList()} title={text}>
            {text}
          </Button>
        )}
      </FormattedMessage>
    </div>
  );
}
